"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const families = {
    primary: 'Nunito, sans-serif',
    secondary: 'Nunito Sans, sans-serif'
};
exports.default = families;
